import React from 'react'
import { AlertModal } from 'app/common/modals/alert'

type Props = {
    onClick: (goBack: boolean) => void,
    onClose: () => void,
    showAllergensAlert: boolean
}

const AllergensAlert = (props: Props) => {
    const { onClick, onClose, showAllergensAlert } = props
    return (
        <AlertModal
            alertTitleKey="clickandcollect.allergens.popup.title"
            alertContentKey="clickandcollect.allergens.popup"
            okLabel="yes"
            leftLabel="no"
            onLeftClick={() => onClick(true)}
            onOkClick={() => onClick(false)}
            isOpen={showAllergensAlert}
            handleClose={() => onClose()}
        />
    )
}

export { AllergensAlert }
